module.exports = __webpack_public_path__ + "img/thumbnail_BlueWildebeest_m_normal.6db7f136.png";